export enum Platform {
  DesktopApp = 'DesktopApp',
  Omen = 'omen',
  OverWolf = 'OverWolf',
  WebApp = 'WebApp',
}
